import React from "react";
import { Route, Routes } from "react-router-dom";
import DriverTransferRequestListScreen from "screens/App/CRM/Driver/DriverTransferRequestListScreen";
import { AdminShipmentTransferScreen } from "screens/App/CRM/ShipmentRequest/AdminShipmentTransferScreen";
import NotFoundScreen from "screens/NotFoundScreen";

const LoadTransferRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<DriverTransferRequestListScreen />} />
      <Route path="add" element={<AdminShipmentTransferScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default LoadTransferRouter;
